const messages = {
    selectAUser: 'Selecciona un usuario',
    selectAManager: 'Selecciona un gerente',
    assignManager: 'Asignar gerente',
    assignProvider: 'Asignar proveedor',
    manager: 'Gerente',
    managers: 'Gerentes',
    userPhone: 'Teléfono del usuario',
    userEmail: 'Correo electrónico del usuario',
    lastMessage: 'Último mensaje',
    lastMessageTime: 'Hora del último mensaje',
    departmentCategory: 'Categoría del departamento',
    phoneNumber: 'Número de teléfono',
    media: 'Medios',
    twilioSid: 'Twilio Sid',
    sales: 'Ventas',
    marketing: 'Marketing',
    coordination: 'Coordinación',
    internal: 'Interno',
    recording: 'Grabación',
    messageHistory: 'Historial de mensajes',
    archivedConversations: 'Conversaciones Archivadas',
    unlinkedConversations: 'Conversaciones No Vinculadas',
    conversationSid: 'SID de Conversación',
    contactPhone: 'Teléfono del Contacto',
    contactName: 'Nombre del Contacto',
    clientLeadId: 'ID del Cliente Potencial',
    importHistory: 'Importar historial',
    userbox: 'Buzón',
    userboxPhone: 'Teléfono del Buzón',
    lastMessageAt: 'Último Mensaje En',
    externalPhone: 'Teléfono Externo',
    viewMessages: 'Ver Mensajes',
    noArchivedConversations: 'No se encontraron conversaciones archivadas',
    noUnlinkedConversations: 'No se encontraron conversaciones no vinculadas',
    selectACategory: 'Selecciona una categoría',
    addNumber: 'Agregar número',
    editNumber: 'Editar número',
    messagingDisabledErrorMessage:
        'El envío de mensajes con este número está desactivado ya que es compartido con múltiples contactos.',
    messagingParticipantNotFoundMessage:
        'Este paciente no ha sido asignado a usted para mensajería. Si cree que es un error, por favor contacte a su administrador del sistema.',
};

export default messages;
